/**
 * 3D models.
 */

// Module styles
import './_3d-models.scss';
